import axios from "@/plugins/axios";

export default {
  async getListVidages() {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    return axios.get("bo/getListVidage?id=" + userId).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async getConfigRules() {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    return axios.get("bo/recurrence/typeExport?id=" + userId).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },

  async getAllRules() {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    return axios.get("bo/recurrence/regleexportables?id=" + userId).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async getAllDests() {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    return axios.get("bo/recurrence/regledestinations?id=" + userId).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async getRulesOfDest(dest: any) {
    return axios
      .get("bo/recurrence/regledestination/" + dest.id + "/regleexportables")
      .then(
        (response: any) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      );
  },
  async getAllAbos() {
    return axios.get("bo/recurrence/abonnements").then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async addRule(params: any) {
    console.log("rule to add");
    console.log(params);
    return axios
      .post("bo/recurrence/regleexportable/", {
        name: params.name,
        cron: params.cron,
        script: params.script,
        fabricExportableClassName: params.fabricExportableClassName,
      })
      .then(
        (response: any) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      );
  },
  async deleteRule(ruleID: any) {
    // console.log(ruleID);
    return axios.delete("bo/recurrence/regleexportable/" + ruleID).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async updateRule(rule: any) {
    return axios.patch("bo/recurrence/regleexportable/" + rule.id, rule).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async addDest(params: any) {
    return axios
      .post("bo/recurrence/regledestination/", {
        name: params.name,
        script: params.script,
        fabricClassName: params.fabricClassName,
        active: params.active,
      })
      .then(
        (response: any) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      );
  },
  async deleteDest(destID: any) {
    return axios
      .delete("bo/recurrence/regledestination/" + destID)
      .then((response: any) => {
        return response.data;
      })
      .catch((error) => {
        const myerror = { message: error.message, status: error.status, error };
        console.log(error);
        if (myerror) {
          throw new Error(JSON.stringify(myerror));
        } else {
          throw new Error();
        }
      });
  },
  async updateDest(dest: any) {
    return axios.patch("bo/recurrence/regledestination/" + dest.id, dest).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async addAbo(params: any) {
    return axios
      .get(
        "bo/recurrence/abonnement/subscribe?regleExportableId=" +
          params.ruleAboID +
          "&regleDestinationId=" +
          params.destAbo
      )
      .then(
        (response: any) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      );
  },
  async updateAbo(params: any) {
    let destAboID = "";
    const de = params.destAbo.map((id: string) => {
      console.log(id);
      return (destAboID += id + ",");
    });
    destAboID = destAboID.slice(0, destAboID.length - 1);
    return axios
      .get(
        `bo/recurrence/abonnement/subscribe?regleExportableId=${params.ruleAboID}&regleDestinationId=${destAboID}`
      )
      .then(
        (response: any) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      );
  },
  async deleteAbo(abo: string) {
    // console.log(ruleID, dest);
    const URL = `bo/recurrence/abonnement/delete?id=${abo}`;
    return axios.delete(URL).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async unsubscribeAbo(ruleID: any, dest: any) {
    // console.log(ruleID, dest);
    const URL = `bo/recurrence/abonnement/unsubscribe?regleExportableId=${ruleID}&regleDestinationId=${dest}`;
    return axios.get(URL).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async getListFabrics() {
    return axios.get("bo/recurrence/typeExport").then(
      (response: any) => {
        return response.data.FabricExportableComposite[0].valeurPossible[3]
          .valeurPossible;
      },
      (error) => {
        throw new Error(JSON.stringify(error));
      }
    );
  },
  async getArcoleStatus(date: any, restaurantId: any) {
    return (
      axios
        .get(
          `withCredentials/arcole/info?restaurantId=${restaurantId}&dateFiscale=${date}`
        )
        // return axios.get(`https://testbuffalo.cashsystemes.com/withCredentials/arcole/info?restaurantId=${restaurantId}&dateFiscale=${date}`, {
        //   auth: {
        //     username: "s.falco",
        //     password: "83700"
        //   }
        // })
        .then(
          (response: any) => {
            return response.data;
          },
          (error) => {
            throw new Error(JSON.stringify(error));
          }
        )
    );
  },
  async relanceExport(date: any, restaurantId: any) {
    return axios
      .get(
        `withCredentials/arcole/publieRestaurant?restaurantId=${restaurantId}&dateFiscale=${date}`
      )
      .then(
        (response: any) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      );
  },

  async customExport(date: any, restaurantId: any, csvFile: boolean) {
    return axios
      .get(
        `withCredentials/arcole/exportRestaurant?restaurantId=${restaurantId}&config=franchises.json&dateFiscale=${date}`,
        { responseType: "blob" }
      )
      .then(
        (response: any) => {
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .replaceAll("\"", "");
          if (csvFile) {
            fileName = fileName.replace(".prn", ".csv");
          }
          const href = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      );
  },
};
